import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { Title } from 'app/components';
import { AccountListComp } from './components';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 3, 8),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 2, 6),
    },
  },
}));

function Account() {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Title prefix="Accounts" />
      <AccountListComp />
    </Box>
  );
}

export default Account;
